export default "__VITE_ASSET__CMnWTMoL__"